import { render, staticRenderFns } from "./TableComponent.vue?vue&type=template&id=3931f5bc"
import script from "./TableComponent.vue?vue&type=script&lang=js"
export * from "./TableComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports